import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { dataTestIds } from 'src/constants/data-test-ids';
import { getSpentTime } from 'utils';
import { useChartFields } from '../../../hooks/useChartFields';
import { useAppointmentData, useChartData } from '../../../stores/appointment/appointment.store';
import { useAppFlags } from '../../../stores/contexts/useAppFlags';

export const ChiefComplaintContainer: FC = () => {
  const { encounter } = useAppointmentData();
  const { chartData } = useChartData();
  const { t } = useTranslation();

  const { data: chartFields } = useChartFields({
    requestedFields: {
      historyOfPresentIllness: {
        _tag: 'history-of-present-illness',
      },
    },
  });

  const { isInPerson } = useAppFlags();
  const chiefComplaint = chartFields?.historyOfPresentIllness?.text;
  const addToVisitNote = chartData?.addToVisitNote?.value;
  const spentTime = getSpentTime(encounter.statusHistory);

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
      data-testid={dataTestIds.telemedEhrFlow.reviewTabChiefComplaintContainer}
    >
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.chiefComplaint.title')}
      </Typography>
      <Typography>{chiefComplaint}</Typography>
      {!isInPerson && addToVisitNote && spentTime && (
        <Typography variant="body2" color="secondary.light">
          {t('telemed.review.chiefComplaint.providerSpent', { spentTime })}
        </Typography>
      )}
    </Box>
  );
};
